import { render, staticRenderFns } from "./contractManagement.vue?vue&type=template&id=0c6e56fa&scoped=true&"
import script from "./contractManagement.vue?vue&type=script&lang=js&"
export * from "./contractManagement.vue?vue&type=script&lang=js&"
import style0 from "./contractManagement.vue?vue&type=style&index=0&id=0c6e56fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e56fa",
  null
  
)

export default component.exports